/* ============================================================================
   Autenticação do admin — leitura de sessão e logout.
   Fonte única da verdade para a sessão do painel.
   ============================================================================ */

const TOKEN_KEY = 'auth_token';
const USER_KEY = 'user_data';

export function getToken() {
  return localStorage.getItem(TOKEN_KEY);
}

export function getUser() {
  try {
    return JSON.parse(localStorage.getItem(USER_KEY) || 'null');
  } catch {
    return null;
  }
}

export function isAdmin() {
  const user = getUser();
  return Boolean(getToken() && user?.isAdmin);
}

export function setSession(token, user) {
  localStorage.setItem(TOKEN_KEY, token);
  localStorage.setItem(USER_KEY, JSON.stringify(user));
}

export function updateUser(patch) {
  const user = { ...(getUser() || {}), ...patch };
  localStorage.setItem(USER_KEY, JSON.stringify(user));
  return user;
}

export function clearSession() {
  localStorage.removeItem(TOKEN_KEY);
  localStorage.removeItem(USER_KEY);
}
